import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { from, Observable, switchMap } from 'rxjs';
import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { PermissionState } from '@capacitor/core';

interface ActivityReportPayload {
  pushNotificationPermission: string;
  os: string;
  osVersion: string;
  clientVersion: string;
}

@Injectable({
  providedIn: 'root',
})
export class ReportingService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.url.api}/reporting/activity`;

  reportPushNotificationPermissionState(state: PermissionState): Observable<void> {
    return from(this.buildActivityReportPayload(state)).pipe(
      switchMap((payload) => this.http.post<void>(this.url, payload)),
    );
  }

  private async buildActivityReportPayload(state: PermissionState): Promise<ActivityReportPayload> {
    const [deviceInfo, clientInfo] = await Promise.all([Device.getInfo(), App.getInfo()]);

    return {
      pushNotificationPermission: state,
      os: deviceInfo.operatingSystem,
      osVersion: deviceInfo.osVersion,
      clientVersion: clientInfo.version,
    };
  }
}
